/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// SEL and SUL are stored as decimals (e.g. 0.03 = 3%).
// A sequential scale: each step is darker than the last, so it reads in grayscale and for
// colorblind viewers, and higher loss is always darker. It avoids green-red pairs, the brand
// cardinal and the error scarlet.
export const CSS_COLORS = {
  under5: '#f2c14e', // gold
  under10: '#ee8b3a', // orange
  under20: '#d1495b', // rose
  under40: '#8e2c7e', // plum
  atLeast40: '#4b1d5e', // deep plum
  noData: '#9b9390', // warm gray
};

export const getMarkerCssColor = value => {
  if (value == null) return CSS_COLORS.noData;
  if (value < 0.05) return CSS_COLORS.under5;
  if (value < 0.1) return CSS_COLORS.under10;
  if (value < 0.2) return CSS_COLORS.under20;
  if (value < 0.4) return CSS_COLORS.under40;
  return CSS_COLORS.atLeast40;
};

const makeSvgIconUrl = fillColor => {
  const svg = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="24" height="36">',
    `<path fill="${fillColor}" stroke="rgba(42,36,34,0.5)" stroke-width="1" d="M12 1C6.48 1 2 5.48 2 11c0 7.5 10 23 10 23S22 18.5 22 11c0-5.52-4.48-10-10-10z"/>`,
    '<circle fill="white" cx="12" cy="11" r="4"/>',
    '</svg>',
  ].join('');
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

const iconCache = {};

const getMarkerIcon = value => {
  const color = getMarkerCssColor(value);
  if (!iconCache[color]) {
    iconCache[color] = makeSvgIconUrl(color);
  }
  return iconCache[color];
};

export default getMarkerIcon;
